/**
 * Hybrid ListItem Component
 * Automatically chooses between Tailwind and styled-components based on props.
 *
 * Routes to the styled-components path when a styled-system prop is present
 * (hasStyledProps) or the component was extended with styled()
 * (isStyledExtension). Otherwise renders the Tailwind path (preferred — no
 * runtime CSS-in-JS).
 *
 * `isBordered` is a semantic public prop, not a styled-system prop, so it maps
 * to a class on the Tailwind path and does not force styled-components.
 */
import * as React from "react";
import {
  hasStyledProps,
  isStyledExtension,
} from "@sproutsocial/seeds-react-system-props";
import type { TypeListItemProps } from "./ListItemTypes";
import ListItemStyled from "./ListItemStyled";
import ListItemTailwind from "./ListItemTailwind";

const ListItemHybrid = React.forwardRef<HTMLLIElement, TypeListItemProps>(
  (props, ref) => {
    if (hasStyledProps(props) || isStyledExtension(props)) {
      return <ListItemStyled {...props} ref={ref} />;
    }

    return <ListItemTailwind {...props} ref={ref} />;
  }
);

ListItemHybrid.displayName = "ListItem";

export default ListItemHybrid;
